import {Component, inject} from '@angular/core';
import {UploadManagerService} from '@services';
import {UploadCardComponent} from './upload-card.component';

@Component({
    selector: 'app-upload-progress-overlay',
    standalone: true,
    imports: [UploadCardComponent],
    templateUrl: './upload-progress-overlay.component.html',
    styleUrls: ['./upload-progress-overlay.component.scss']
})
export class UploadProgressOverlayComponent {
    protected uploadManager = inject(UploadManagerService);
}
